import { Card, Table } from 'semantic-ui-react';
import React from 'react';
import { t } from 'i18next';
import { LeadCreator } from '../../../../types/LeadCreator';
import CopyContentComponent from '../../../misc/CopyContent.component';

type LeadCreatorComponentProps = {
    leadCreator: LeadCreator;
    copy?: boolean;
};

export default function LeadCreatorComponent(props: LeadCreatorComponentProps) {
    function copyable(value: string): React.ReactElement {
        return props.copy ? <CopyContentComponent>{value}</CopyContentComponent> : <>{value || ''}</>;
    }

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t('lead.detail.box.leadCreator.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={4}>{t(`lead.detail.box.leadCreator.firstName`)}</Table.Cell>
                                <Table.Cell singleLine>{copyable(props.leadCreator.firstName)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>{t(`lead.detail.box.leadCreator.lastName`)}</Table.Cell>
                                <Table.Cell singleLine>{copyable(props.leadCreator.lastName)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}>{t(`lead.detail.box.leadCreator.email`)}</Table.Cell>
                                <Table.Cell singleLine>{copyable(props.leadCreator.email)}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
        </Card>
    );
}
